import { LegalPage } from "../components/LegalPage";
import { TERMS_UPDATED, TERMS_SECTIONS } from "../data/termsOfUse";

export default function TermsOfUse() {
  return <LegalPage title="Terms of Use" updated={TERMS_UPDATED} sections={TERMS_SECTIONS} testId="terms-of-use-page" />;
}
